export { JournalPage } from './JournalPage'
export { getSeoData } from './fractals'
